import {connect} from 'react-redux'
import Device from 'components/Devices/Device'
import {selectDevice} from 'modules/devices/list/selectors'


export default connect(
    (state, {panelId, deviceId}) => ({
        device: selectDevice(state, {panelId, deviceId}),
    })
)(Device)